import { render, staticRenderFns } from "./AutoScroll.vue?vue&type=template&id=250ccb64&scoped=true&"
import script from "./AutoScroll.vue?vue&type=script&lang=ts&"
export * from "./AutoScroll.vue?vue&type=script&lang=ts&"
import style0 from "./AutoScroll.vue?vue&type=style&index=0&id=250ccb64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250ccb64",
  null
  
)

export default component.exports